import { FC } from 'react'
import { redirect, useNavigate } from 'react-router-dom'
import './card.css'

// COMPONENTS
import * as Icons from '@icons'
import AddToWalletButton from '@components/atoms/add-to-wallet-button'
import Card from '@components/atoms/card'
import Divider from '@components/atoms/divider'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { parseTeraUserData } from '@schemas'
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'


const Component: FC<{}> = () => {
    const { physicalCard, address } = useLoader<typeof loader>()
    const navigate = useNavigate()
    const activeGroup = physicalCard?.activeGroup
    const status = !!activeGroup ? 'active' : 'not active'

    return (
        <div className='flex flex-col gap-4'>
            <AddToWalletButton
                navOptions={{
                    state: {
                        isPhysical: true,
                        returnUrl: '/account/physical-card'
                    }
                }}
            />
            <Card>
                <div className="flex flex-row flex-wrap items-center justify-between">
                    <p className="text-body-2 text-gray-500"><strong>Card Status</strong></p>
                    <p className="text-body"><strong className={`text-${status === 'active' ? 'green-600' : 'red-500'}`}>{status === 'active' ? 'Active' : 'Not Active'}</strong></p>
                </div>
                <p className="text-body-2 text-gray-500">You can only use this card with one group at a time!</p>
                <Divider />
                <div onClick={() => navigate(`${status === 'active' ? `/group/${activeGroup}` : '/group'}`)} className="flex flex-row flex-wrap items-center justify-between cursor-pointer">
                    <p className="text-body-2"><strong>{status === 'active' ? 'View Active Group' : 'Create a Group'}</strong></p>
                    <Icons.Chevron tint={'var(--splitcard-black)'} width="1.25rem" height="1.25rem" facing="right" />
                </div>
            </Card>
            <Card>
                <div className="flex flex-row flex-wrap items-center justify-between">
                    <p className="text-body"><strong>Billing Address</strong></p>
                    {address?.line1 ? (
                        <div className="flex flex-col text-right">
                            <p className="text-body text-gray-500"><strong>{address.line1}</strong></p>
                            <p className="text-body text-gray-500"><strong>{address.line2}</strong></p>
                            <p className="text-body-2 text-gray-500">{address.city}, {address.state} {address.postal_code}</p>
                        </div>
                    ) : <p className="text-body-2 text-gray-500">No saved billing address</p>}
                </div>
            </Card>
        </div>)
}

const loader = createAuthenticatedLoader(async ({ }, Clerk) => {
    const tera = parseTeraUserData(Clerk.user?.publicMetadata.tera)
    if (!tera.address?.line1) return redirect('./add-billing')
    else return parseTeraUserData(Clerk.user?.publicMetadata.tera)
})

const UserCardDefaultRoute: RouteObject = {
    index: true,
    Component,
    loader,
}

export { UserCardDefaultRoute }
